import React from "react";
import VerifyOpt from "../../components/verifyOtp/VerifyOtp";

const VerifyOptPage = () => {
  return <VerifyOpt />;
};

export default VerifyOptPage;
